import { Pipe, PipeTransform } from '@angular/core';
import { AppConfigService } from '../../../app/services/app-config.service';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Pipe({
    name: 'translateApplicationName',
    standalone: true
})
export class TranslateApplicationNamePipe implements PipeTransform {
    name = this.appConfigService.getAppConfig().browserTitle;

    constructor(private appConfigService: AppConfigService,
                private translate: TranslateService) {
    }

    transform(value: string): Observable<string> {
        if (!!value) {
           return this.translate.get(value, {name: this.name});
        }
    }
}
